import * as React from "react";
import {AwardItemRequest, AwardItemResponse, ListRequest, ProductView} from "../../../../generated/protocol";
import {LoadingViewState, RouterView} from "../RouterView";
import {Form, FormListener} from "../../form/Form";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {Submit} from "../../form/Submit";
import {kernel} from "../../../ioc/IOCHelper";
import {FormSubmitError, FormSubmitSuccess} from "../../form/FormFeedback";
import {ITEM_SERVICE_NAME, ItemService} from "../../../service/admin/ItemService";
import {FormTextArea} from "../../form/FormTextArea";

interface State extends LoadingViewState {
    itemAward?: AwardItemRequest;
    response?: AwardItemResponse;
    validationMap?: any;
}

export class ItemAwardView extends RouterView<{ params: { id: string, category?: string } }, State> implements FormListener<ProductView> {

    itemService: ItemService;

    constructor() {
        super();
        this.state = {validationMap: {}, loading: true, itemAward: {}, response: {nrOfResults: 0}};
        this.itemService = kernel.get<ItemService>(ITEM_SERVICE_NAME);
    }

    loadContent(): Promise<any> {
        return this.init();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.id != this.props.params.id) {
            this.init();
        }
    }

    itemListRequest(): ListRequest {
        return {
            limit: 100,
            offset: 0,
            ascending: true,
            orderBy: 'name'
        };
    }

    init(): Promise<any> {
        return undefined;
    }

    onSubmit(): Promise<any> {
        this.state.itemAward.nameId = this.props.params.id;

        return this.itemService.awardAll(this.state.itemAward).then(result => {
            let theResult: AwardItemResponse = result;
            this.setState({loading: false, response: theResult});

        }).catch((err) => {
            console.error("Server error when submitting form ", err);
            throw err.message;
        });
    }

    onSubmitError() {

    }

    formDidUpdate(formModel: ProductView, validationMap: any) {
        this.setState({itemAward: formModel, validationMap: validationMap});
    }

    getItemDisplayValue(item) {
        return item.name;
    }

    renderContent() {
        const isTicketOrJsngEntry = this.props.params.category === 'TICKET' || this.props.params.category === 'JSNG_ENTRY';
        const isJsngEntry = this.props.params.category === 'JSNG_ENTRY';
        return (
            <div className="ibox-content" height="300px">
                <Form className="form-horizontal" formListener={this}
                      modelObject={this.state.itemAward}
                      validationMap={this.state.validationMap}>


                    <div className="row">
                        <div className="col-lg-12">
                            <div className="float-e-margins">
                                <FormInput type="hidden" className="form-control" model="nameId"
                                           value={this.props.params.id}/>

                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Equipped</label>
                                    <div className="col-sm-10">
                                        <FormInput type="checkbox" model="equipped"/>
                                    </div>
                                </FormGroup>

                                {isTicketOrJsngEntry ? (<FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Free Giveaway</label>
                                    <div className="col-sm-10">
                                        <FormInput type="checkbox" model="isFree" checked={isJsngEntry} />
                                    </div>
                                </FormGroup>) : null}

                                <FormGroup className="form-group" model="description">
                                    <label className="col-sm-2 control-label">Players</label>
                                    <div className="col-sm-10">
                                        <FormTextArea type="text" model="players" className="form-control"/>
                                    </div>
                                    <div className="col-sm-2"></div>
                                    <div className="col-sm-10">
                                        <span className="help-block m-b-none">
                                            Comma or Newline separated list of <i>cubeia user ids</i>
                                        </span>
                                    </div>
                                </FormGroup>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <FormSubmitError/>
                            <FormSubmitSuccess
                                text={"Item was awarded successfully to " + this.state.response.nrOfResults + " players"}/>
                            <div className="form-group">
                                <div className="col-sm-12">
                                    <Submit className="ladda-button btn-lg btn-primary">Award Item</Submit>
                                </div>
                            </div>
                        </div>
                    </div>

                </Form>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/view/item/ItemAwardView.tsx